module.exports = __webpack_public_path__ + "media/img/new-assets/emoji/party-0ff32b2d85a506ba35bfcf29a144a4c0.png";